import React from 'react';
import styled from 'styled-components/macro';
import { WaiveCard } from './WaiveCard';
import { TermCard } from './TermCard';
import { ChangeBillDateCard } from './ChangeBillDateCard';
import { useDispatch, useSelector } from 'react-redux';
import { selectAmendment, selectOACLNummber } from '../../slice/selectors';
import { AmendmentType, amendment } from '../../slice/types';
import { BIUpdateCard } from './BIUpdateCard';
import { useContractDataSlice } from '../../slice';
import { apiList } from '../../../../../locales/apiList';
import { UseAxios } from '../../../../../utils/UseAxios';
import { translations } from '../../../../../locales/translations';
import { useWorkListStateSlice } from '../../../WorkListPage/slice';

export default function AmendmentDrawer(props) {
  const { reloadList } = props;
  const { actions } = useContractDataSlice();
  const worklistAction = useWorkListStateSlice().actions;
  const dispatch = useDispatch();
  const oacl = useSelector(selectOACLNummber);
  const amendmentData = useSelector(selectAmendment);
  const [amendmentComponent, setAmendmentComponent] = React.useState<JSX.Element[]>([]);

  React.useEffect(() => {
    let versionNumber = 0;
    setAmendmentComponent([]);
    const amendmentComponents:JSX.Element[] = [];
    if (amendmentData) {
      let lastBIData: amendment | null = null;
      amendmentData.forEach(amendment => {
        if (amendment.type) {
          let newElement: JSX.Element | undefined = undefined;
          let item: amendment = {
            type: amendment.type,
            data: amendment.data,
            status: amendment.status,
            relatedSections: amendment.relatedSections,
            statusReasons: amendment.statusReasons,
          };
          if (amendment.type === AmendmentType.CHANGEBILLDATE) {
            newElement = <ChangeBillDateCard key={amendmentComponents.length} data={item} />
          } else if (amendment.type === AmendmentType.TERMINATION) {
            newElement = <TermCard key={amendmentComponents.length} data={item} />
          } else if (amendment.type === AmendmentType.WAIVER) {
            newElement = <WaiveCard key={amendmentComponents.length} data={item} />
          } else if (amendment.type === AmendmentType.BIUPDATE) {
            newElement = <BIUpdateCard key={amendmentComponents.length} data={item} index={++versionNumber} lastBIData={lastBIData}  />
            lastBIData = item;
          }
          if (newElement) {
            amendmentComponents.splice(0, 0, newElement)
          }
        }
      });
      setAmendmentComponent(amendmentComponents);
    }
  }, [amendmentData]);

  React.useEffect(() => {
    const requestURL = `${apiList.getAmendmentsURL}${oacl}`;
    UseAxios(requestURL, 'get')
      .then(function(response) {
        dispatch(actions.updateAmendments(response.data));
      })
      .catch(function(error) {
        console.log('error: ' + JSON.stringify(error));
        dispatch(worklistAction.updateErrorWordings(translations.error.commonError));
        dispatch(worklistAction.updateErrorDialog(true));
      });
  }, [reloadList]);

  return (
    <Wrapper>
      {amendmentComponent}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  width: 100%;
  background-color: ${p => p.theme.containerBackground};
  border-radius: 5px;
  margin: -5px -10px 0 5px;
  font-size: 12px;
  overflow-y: auto;
  max-height: 1000px;

  .amendment-header {
    font-size: 16px;
  }

  .html,
  .body {
    height: 100%;
  }
`;
